export enum AuthMethod {
    PASSWORD = "PASSWORD",
    UAA = "UAA",
    TARA = "TARA"
}
